import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import Preloading from "../../../components/basics/Preloading";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Paginations from "../../../components/paginaton/Paginations";
import EditMerchantModal from "./EditMerchantModal";
import DeleteMerchantModal from "./DeleteMerchantModal";

const MerchantWallet = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);
  const [deleteShow, setDeleteShow] = useState(null);
  const [merchantInfo, setMerchantInfo] = useState([]);
  const [totalPages, setTotalPages] = useState("");
  const [selectedMerchantId, setSelectedMerchantId] = useState(null);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    size: 20,
    part: 1,
    code: "",
    mobile: "",
    firstName: "",
    lastName: "",
    creditable: "",
    total: 0,
    parts: 0,
    merchantType: 0,
  });
  const [formModel, setFormModel] = useState({
    merchantId: 0,
    creditAmont: 0,
    creditable: true,
    branchId: branchId,
  });
  const [merchant, setMerchant] = useState({
    id: 0,
    merchantType: 1,
    firstName: "",
    lastName: "",
    genderType: 1,
    identityNumber: "",
    nationalNumber: "",
    mobile: "",
    phone: "",
    email: "",
    companyName: "",
    nikCompanyName: "",
    economicCode: "",
    registrationNumber: "",
    webSiteAddress: "",
    faxNumber: "",
    creditable: false,
    branchId: branchId,
  });
  const [merchantFilter, setMerchantFilter] = useState({
    branchId: branchId,
    size: 20,
    part: 1,
    code: "",
    mobile: "",
    firstName: "",
    lastName: "",
    total: 0,
    parts: 0,
    merchantType: 0,
    creditable: null,
  });
  const [merchantList, setMerchantList] = useState([]);
  const [showsearchMerchantModal, setShowSearchMerchantModal] = useState(false);
  const [userAddresses, setUserAddresses] = useState([]);
  const addressModel = {
    id: 0,
    title: "",
    address: "",
    phone: "",
    zipCode: "",
    faxNumber: "",
    cityId: null,
    userId: 0,
    shipmentId: null,
  };
  const [shipmentsInfo, setShipmentsInfo] = useState({
    branchId,
    title: "",
    size: 200,
    part: 1,
  });
  const [shipments, setShipments] = useState([]);
  const [showcreateMerchantModal, setShowCreateMerchantModal] = useState(false);
  const [accountBalance, setAccountBalance] = useState(0);

  const handleClose = () => setShow(null);
  const handleShow = (id) => {
    setShow(id);
  };

  const handleDeleteClose = () => setDeleteShow(null);
  const handleDeleteShow = (id) => {
    setDeleteShow(id);
  };

  const getGridData = async () => {
    const resp = await apiMethod.getMerchants(
      filterModel.branchId,
      filterModel.size,
      filterModel.part,
      filterModel.code,
      filterModel.mobile,
      filterModel.firstName,
      filterModel.lastName,
      filterModel.merchantType,
      filterModel.creditable
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
      setTotalPages(resp.total);
    }
  };

  const getShipments = async () => {
    const resp = await apiMethod.getShipmentCosts(
      shipmentsInfo.branchId,
      shipmentsInfo.title,
      shipmentsInfo.size,
      shipmentsInfo.part
    );
    if (methods.showApiErrors(resp)) {
      setShipments(resp.data);
    }
  };

  // const getMerchants = async () => {
  //   const resp = await apiMethod.getMerchants(merchantFilter.branchId, merchantFilter.size, merchantFilter.part, merchantFilter.code, merchantFilter.mobile, merchantFilter.firstName, merchantFilter.lastName, merchantFilter.merchantType, merchantFilter.creditable)
  //   if (methods.showApiErrors(resp)) {
  //     merchantFilter.total = resp.total;
  //     merchantFilter.parts = methods.calcPageParts(resp.total, merchantFilter.size);
  //     setMerchantFilter({ ...merchantFilter });
  //     setMerchantList(resp.data);
  //   }
  // };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getShipments();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetForm = () => {
    formModel.merchantId = 0;
    formModel.creditAmont = 0;
    formModel.creditable = null;
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetMerchant = () => {
    merchant.id = 0;
    merchant.merchantType = 1;
    merchant.firstName = "";
    merchant.lastName = "";
    merchant.genderType = 1;
    merchant.identityNumber = "";
    merchant.nationalNumber = "";
    merchant.mobile = "";
    merchant.phone = "";
    merchant.email = "";
    merchant.companyName = "";
    merchant.nikCompanyName = "";
    merchant.economicCode = "";
    merchant.registrationNumber = "";
    merchant.webSiteAddress = "";
    merchant.faxNumber = "";
    setMerchant({ ...merchant });
    userAddresses.splice(0, userAddresses.length);
    setUserAddresses([]);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.firstName = "";
    filterModel.lastName = "";
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.code = "";
    filterModel.mobile = "";
    filterModel.creditable = "";
    filterModel.merchantType = 0;
    setFilterModel({ ...filterModel });
  };

  const resetMerchantFilter = () => {
    merchantFilter.branchId = branchId;
    merchantFilter.firstName = "";
    merchantFilter.lastName = "";
    merchantFilter.code = "";
    merchantFilter.mobile = "";
    merchantFilter.size = 20;
    merchantFilter.part = 1;
    merchantFilter.total = 0;
    merchantFilter.parts = 0;
    merchantFilter.merchantType = 0;
    merchantFilter.creditable = "";
  };

  const merchantWalletInfo = async (id) => {
    setLoading(true);

    const resp = await apiMethod.getMerchantWalletInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.merchantId = id;
    formModel.creditAmont = resp.data.creditAmont;
    formModel.creditable = resp.data.creditable;
    formModel.branchId = resp.data.branchId;
    setAccountBalance(resp.data.accountBalance);
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createMerchantWallet = async () => {
    setLoading(true);

    try {
      const resp = await apiMethod.createMerchantWallet(formModel);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const isValidMerchant = () => {
    let errors = [];

    if (!merchant.merchantType) {
      errors.push("نوع مشتری باید مقدار داشته باشد.");
    }

    if (merchant.merchantType === 1) {
      if (methods.isNullOrEmptyString(merchant.firstName)) {
        errors.push("نام مشتری باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.lastName)) {
        errors.push("نام خانوادگی مشتری باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.mobile)) {
        errors.push("موبایل مشتری باید مقدار داشته باشد.");
      }
    } else if (merchant.merchantType === 2) {
      if (methods.isNullOrEmptyString(merchant.firstName)) {
        errors.push("نام شرکت باید مقدار داشته باشد.");
      }
      // if (methods.isNullOrEmptyString(merchant.companyName)) {
      //   errors.push("نام اختصاصی شرکت باید مقدار داشته باشد.");
      // }
      if (methods.isNullOrEmptyString(merchant.mobile)) {
        errors.push("موبایل مشتری باید مقدار داشته باشد.");
      }
    }

    userAddresses.forEach((item) => {
      if (methods.isNullOrEmptyString(item.title)) {
        errors.push("عنوان آدرس باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(item.address)) {
        errors.push("آدرس باید مقدار داشته باشد.");
      }
    });

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const createMerchant = async () => {
    if (!isValidMerchant()) return false;

    setLoading(true);

    const apiResp = await apiMethod.createMerchantWithAddress({
      Merchant: merchant,
      UserAddresses: userAddresses,
    });

    if (!methods.showApiErrors(apiResp)) {
      setShowCreateMerchantModal(false);
      setLoading(false);
    }
    await getGridData();
    setShowCreateMerchantModal(false);
    resetMerchant();
    setLoading(false);
  };

  const toggleCredittable = async (merchantId) => {
    setLoading(true);
    try {
      const response = await apiMethod.changeCreditableMerchant(merchantId);
      if (methods.showApiErrors(response)) {
        await getGridData();
        setShowSearchMerchantModal(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const searchItemModal = async () => {
    setLoading(true);
    // await getMerchants();
    setLoading(false);
  };

  const clearSearchModal = async () => {
    setLoading(true);
    resetMerchantFilter();
    // await getMerchants();
    setLoading(false);
  };

  const addAddressField = () => {
    userAddresses.push(addressModel);
    setUserAddresses([...userAddresses]);
  };

  const addressTitleChange = (index, title) => {
    userAddresses[index].title = title;
    setUserAddresses([...userAddresses]);
  };

  const addressTextChange = (index, text) => {
    userAddresses[index].address = text;
    setUserAddresses([...userAddresses]);
  };

  const addressShipmentChange = (index, shimpment) => {
    userAddresses[index].shipmentId = shimpment;
    setUserAddresses([...userAddresses]);
  };
  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getMerchantInfo(id);
    if (methods.showApiErrors(resp)) {
      setMerchantInfo(resp.data);
    }
    setLoading(false);
    handleShow(id);
  };

  const selectMerchantDelete = async (id) => {
    handleDeleteShow(id);
    setSelectedMerchantId(id);
  };

  const deleteMerchant = async () => {
    setLoading(true);
    const resp = await apiMethod.removeMerchant(selectedMerchantId);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    handleDeleteClose();
    await getGridData();
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/#5`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/sale/${branchId}/#5`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                مدیریت مشتریان
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                مدیریت مشتریان
                {/* <a href={`/sale/${branchId}/softwareGuide/#section9`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a> */}
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-2">
                  <div className="col-12 col-md-4 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      نام
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.firstName}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            firstName: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      نام خانوادگی
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.lastName}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            lastName: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      شماره تماس
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.mobile}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            mobile: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    <label htmlFor="merchantTypeSelect" className="form-label">
                      نوع مشتری
                    </label>
                    <select
                      id="merchantTypeSelect"
                      className="form-select form-select-md"
                      value={filterModel.merchantType}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          merchantType: e.target.value,
                          part: 1,
                        });
                      }}
                    >
                      <option value="">انتخاب کنید</option>
                      <option value={1}>حقیقی</option>
                      <option value={2}>حقوقی</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2">
                    <label htmlFor="creditableSelect" className="form-label">
                      نوع اعتبار
                    </label>
                    <select
                      id="creditableSelect"
                      className="form-select form-select-md"
                      value={
                        filterModel.creditable === ""
                          ? ""
                          : filterModel.creditable
                          ? "1"
                          : "0"
                      }
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          creditable:
                            e.target.value === "1"
                              ? true
                              : e.target.value === "0"
                              ? false
                              : "",
                        });
                      }}
                    >
                      <option value="">انتخاب کنید</option>
                      <option value={1}>اعتباری</option>
                      <option value={0}>غیر اعتباری</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4 col-lg-2"style={{ marginTop: "35px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={() => {
                        searchItem();
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className="">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          مشتری‌ جدید
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">نام و نام خانوادگی</th>
                      <th scope="col vertical-center">کد اشتراک</th>
                      <th scope="col vertical-center" width="150px">
                        شماره تماس
                      </th>
                      <th scope="col vertical-center">آدرس</th>
                      <th scope="col vertical-center" width="150px">
                        نوع مشتری
                      </th>
                      <th scope="col vertical-center">کیف‌پول</th>
                      <th scope="col vertical-center" width="100px">
                        اعتباری / غیر‌اعتباری
                      </th>
                      <th width="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{`${item.firstName} ${item.lastName}`}</td>
                        <td>{item.merchantCode}</td>
                        <td>{item.mobile}</td>
                        <td>
                          <Link
                            to={`/sale/${branchId}/merchantAddress/${item.id}`}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-purple"
                            >
                              آدرس
                            </button>
                          </Link>
                        </td>
                        <td>
                          {item.merchantType === 1
                            ? "حقیقی"
                            : item.merchantType === 2
                            ? "حقوقی"
                            : ""}
                        </td>
                        <td>
                          {item.creditable === true ? (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-purple"
                              onClick={() => merchantWalletInfo(item.id)}
                            >
                              کیف‌پول
                            </button>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              item.creditable
                                ? "btn-outline-success"
                                : "btn-outline-danger"
                            }`}
                            style={{ width: "50px" }}
                            onClick={() => toggleCredittable(item.id)}
                          >
                            {item.creditable ? (
                              <i class="bi bi-check-all"></i>
                            ) : (
                              <i class="bi bi-x-circle"></i>
                            )}
                          </button>
                          {/* {item.creditable ? "اعتباری" : "غیر اعتباری"} */}
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className="btn btn-sm btn-outline-purple mx-1"
                            type="button"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <EditMerchantModal
                            show={show === item.id}
                            onHide={handleClose}
                            info={merchantInfo}
                            setLoading={setLoading}
                            getGridData={getGridData}
                          />
                          <button
                            onClick={() => selectMerchantDelete(item.id)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                          <DeleteMerchantModal
                            show={deleteShow === item.id}
                            onHide={handleDeleteClose}
                            deleteMerchant={deleteMerchant}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const openNewForm = async () => {
    resetForm();
    setShowCreateMerchantModal(true);
  };

  const closeModal = () => {
    resetForm();
    resetMerchant();
    setShowFormModal(false);
    setShowCreateMerchantModal(false);
    setShowSearchMerchantModal(false);
  };

  const showMerchants = async () => {
    setLoading(true);
    // await getMerchants();
    setLoading(false);
    setShowSearchMerchantModal(true);
  };

  const tipAmountChanged = (tipAmount) => {
    if (tipAmount === "" || tipAmount === null || tipAmount === undefined)
      tipAmount = "0";
    tipAmount = methods.allReplace(tipAmount, ",", "");
    formModel.creditAmont = parseInt(tipAmount);
    setFormModel({ ...formModel });
  };

  const WalletModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش کیف‌پول</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="creditAmont" className="form-label ">
                    موجودی حساب:{" "}
                  </label>
                  {methods.addNumSeperator(accountBalance)} ریال
                </div>
                <div className="col-md-12">
                  <label htmlFor="creditAmont" className="form-label ">
                    مقدار اعتبار
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="creditAmont"
                    name="creditAmont"
                    value={methods.addNumSeperator(formModel.creditAmont)}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (
                        value === "" ||
                        value === null ||
                        value === undefined
                      ) {
                        value = "0";
                      }
                      value = value.replace(/,/g, "");
                      const parsed = parseInt(value, 10) || 0;
                      setFormModel({
                        ...formModel,
                        creditAmont: parsed,
                      });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formModel.creditable}
                      onChange={(e) => {
                        setFormModel({
                          ...formModel,
                          creditable: e.target.checked,
                        });
                      }}
                      className=""
                    />
                    <span className="me-1">مجوز استفاده از اعتبار</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                type="submit"
                className="btn custome-btn btn-purple w-50"
                onClick={() => {
                  createMerchantWallet();
                }}
              >
                ثبت وذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const createMerchantModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showcreateMerchantModal ? "block" : "none" }}
      >
        <div className="modal-dialog  modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد مشتری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="merchantType" className="form-label">
                    نوع مشتری
                  </label>
                  <select
                    id="merchantType"
                    className="form-select"
                    aria-label="Default select example"
                    value={merchant.merchantType}
                    onChange={(e) => {
                      setMerchant({
                        ...merchant,
                        merchantType: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value={1}>حقیقی</option>
                    <option value={2}>حقوقی</option>
                  </select>
                </div>
                {merchant.merchantType === 1 && (
                  <>
                    <div className="col-md-12">
                      <label
                        htmlFor="firstname"
                        className="form-label required-label"
                      >
                        نام
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        value={merchant.firstName || ""}
                        onChange={(e) => {
                          setMerchant({
                            ...merchant,
                            firstName: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label
                        htmlFor="lastname"
                        className="form-label required-label"
                      >
                        نام‌خانوادگی
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        value={merchant.lastName || ""}
                        onChange={(e) => {
                          setMerchant({
                            ...merchant,
                            lastName: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="nationalNumber" className="form-label">
                        شماره‌ملی
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="nationalNumber"
                        value={merchant.nationalNumber || ""}
                        onChange={(e) => {
                          setMerchant({
                            ...merchant,
                            nationalNumber: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label
                        htmlFor="mobile"
                        className="form-label required-label"
                      >
                        تلفن همراه
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="mobile"
                        value={methods.formatPhoneNumber(merchant.mobile) || ""}
                        onChange={(e) => {
                          setMerchant({ ...merchant, mobile: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label
                        htmlFor="phone"
                        className="form-label required-label"
                      >
                        تلفن ثابت
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={merchant.phone}
                        onChange={(e) => {
                          setMerchant({ ...merchant, phone: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={merchant.creditable}
                          onChange={(e) => {
                            setMerchant({
                              ...merchant,
                              creditable: e.target.checked,
                            });
                          }}
                        />
                        <span className="me-1">مجوز استفاده از اعتبار</span>
                      </label>
                    </div>
                    {userAddresses.map((item, index) => (
                      <div key={index} className="col-md-12">
                        <label
                          htmlFor={`location${index}`}
                          className="form-label"
                        >
                          انتخاب محل
                        </label>
                        <select
                          id={`location${index}`}
                          className="form-select mb-3"
                          aria-label="Default select example"
                          value={item?.shipmentId ?? ""}
                          onChange={(e) => {
                            const value =
                              e.target.value === ""
                                ? null
                                : Number(e.target.value);
                            addressShipmentChange(index, value);
                          }}
                        >
                          <option value="">محل آدرس</option>
                          {shipments.map((shipment, sindx) => (
                            <option key={sindx} value={shipment.id}>
                              {shipment.areaTitle} -{" "}
                              {methods.addNumSeperator(shipment.price)}
                            </option>
                          ))}
                        </select>
                        <label
                          htmlFor={`addresstitle${index}`}
                          className="form-label"
                        >
                          عنوان آدرس
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id={`addresstitle${index}`}
                          value={item.title}
                          onChange={(e) =>
                            addressTitleChange(index, e.target.value)
                          }
                        />
                        <label
                          htmlFor={`address${index}`}
                          className="form-label"
                        >
                          آدرس
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          id={`address${index}`}
                          value={item.address}
                          onChange={(e) =>
                            addressTextChange(index, e.target.value)
                          }
                        />
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="btn custome-btn btn-link-green"
                        onClick={addAddressField}
                      >
                        اضافه کردن آدرس
                      </button>
                    </div>
                  </>
                )}
                {merchant.merchantType === 2 && (
                  <>
                    <div className="col-md-12">
                      <label
                        htmlFor="firstName"
                        className="form-label required-label"
                      >
                        نام شرکت
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        value={merchant.firstName || ""}
                        onChange={(e) => {
                          setMerchant({
                            ...merchant,
                            firstName: e.target.value,
                            companyName: e.target.value,
                          });
                        }}
                      />
                    </div>
                    {/* <div className="col-md-12">
                      <label
                        htmlFor="companyName"
                        className="form-label required-label"
                      >
                        نام تجاری شرکت
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="companyName"
                        value={merchant.companyName || ""}
                        onChange={(e) => {
                          setMerchant({
                            ...merchant,
                            companyName: e.target.value,
                          });
                        }}
                      />
                    </div> */}
                    <div className="col-md-12">
                      <label htmlFor="economicCode" className="form-label">
                        شناسه اقتصادی
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="economicCode"
                        value={merchant.economicCode || ""}
                        onChange={(e) =>
                          methods.validateNumberInput(e.target.value) &&
                          setMerchant({
                            ...merchant,
                            economicCode: e.target.value,
                          })
                        }
                      />
                    </div>
                    {/* <div className="col-md-12">
                      <label
                        htmlFor="registrationNumber"
                        className="form-label"
                      >
                        شماره ثبت
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="registrationNumber"
                        value={merchant.registrationNumber || ""}
                        onChange={(e) =>
                          methods.validateNumberInput(e.target.value) &&
                          setMerchant({
                            ...merchant,
                            registrationNumber: e.target.value,
                          })
                        }
                      />
                    </div> */}
                    <div className="col-md-12">
                      <label
                        htmlFor="phone"
                        className="form-label required-label"
                      >
                        شماره موبایل
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={merchant.mobile}
                        onChange={(e) => {
                          setMerchant({ ...merchant, mobile: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={merchant.creditable}
                          onChange={(e) => {
                            setMerchant({
                              ...merchant,
                              creditable: e.target.checked,
                            });
                          }}
                        />
                        <span className="me-1">مجوز استفاده از اعتبار</span>
                      </label>
                    </div>
                    {userAddresses.map((item, index) => (
                      <div key={index} className="col-md-12">
                        <label
                          htmlFor={`location${index}`}
                          className="form-label"
                        >
                          انتخاب محل
                        </label>
                        <select
                          id={`location${index}`}
                          className="form-select mb-3"
                          aria-label="Default select example"
                          value={item?.shipmentId ?? ""}
                          onChange={(e) => {
                            const value =
                              e.target.value === ""
                                ? null
                                : Number(e.target.value);
                            addressShipmentChange(index, value);
                          }}
                        >
                          <option value="">محل آدرس</option>
                          {shipments.map((shipment, sindx) => (
                            <option key={sindx} value={shipment.id}>
                              {shipment.areaTitle} -{" "}
                              {methods.addNumSeperator(shipment.price)}
                            </option>
                          ))}
                        </select>
                        <label
                          htmlFor={`addresstitle${index}`}
                          className="form-label"
                        >
                          عنوان آدرس
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id={`addresstitle${index}`}
                          value={item.title}
                          onChange={(e) =>
                            addressTitleChange(index, e.target.value)
                          }
                        />
                        <label
                          htmlFor={`address${index}`}
                          className="form-label"
                        >
                          آدرس
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          id={`address${index}`}
                          value={item.address}
                          onChange={(e) =>
                            addressTextChange(index, e.target.value)
                          }
                        />
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="btn custome-btn btn-link-green"
                        onClick={addAddressField}
                      >
                        اضافه کردن آدرس
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                onClick={createMerchant}
                type="button"
                className="btn custome-btn btn-purple w-50"
              >
                ثبت و ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const callPagerMerchant = async (i) => {
    setLoading(true);
    merchantFilter.part = i;
    setMerchantFilter({ ...merchantFilter });
    // await getMerchants();
    setLoading(false);
  };

  const movePagerPartMerchant = (isForward) => {
    if (isForward) {
      if (merchantFilter.parts < merchantFilter.part + 1) {
        return false;
      }
      callPagerMerchant(merchantFilter.part + 1);
    } else {
      if (merchantFilter.part === 1) {
        return false;
      }
      callPagerMerchant(merchantFilter.part - 1);
    }
  };

  const makePagerItemsMerchant = () => {
    let pages = [];
    for (let i = 1; i <= merchantFilter.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            merchantFilter.part === i
              ? "page-item active mx-1"
              : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPagerMerchant(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const searchMerchantModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showsearchMerchantModal ? "block" : "none" }}
      >
        <div className="modal-dialog  modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">جستجوی مشتری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-1 mb-3">
                <div className="col-12 col-md-1">
                  <label htmlFor="funit" className="form-label">
                    نام
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={merchantFilter.firstName}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        firstName: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-2">
                  <label htmlFor="fstatus" className="form-label">
                    نام خانوادگی
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={merchantFilter.lastName}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        lastName: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-1">
                  <label htmlFor="forder" className="form-label">
                    کد اشتراک
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={merchantFilter.code}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        code: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-2">
                  <label htmlFor="forder" className="form-label">
                    موبایل
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={merchantFilter.mobile}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        mobile: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                </div>
                <div className="col-12 col-md-2">
                  <label htmlFor="merchantType" className="form-label">
                    نوع مشتری
                  </label>
                  <select
                    id="merchantType"
                    className="form-select"
                    aria-label="Default select example"
                    value={merchantFilter.merchantType}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        merchantType: e.target.value,
                        part: 1,
                      });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value={1}>حقیقی</option>
                    <option value={2}>حقوقی</option>
                  </select>
                </div>
                <div className="col-12 col-md-2">
                  <label htmlFor="merchantType" className="form-label">
                    اعتباری / غیر‌اعتباری
                  </label>
                  <select
                    id="merchantType"
                    className="form-select"
                    aria-label="Default select example"
                    value={merchantFilter.creditable}
                    onChange={(e) => {
                      setMerchantFilter({
                        ...merchantFilter,
                        creditable:
                          e.target.value === ""
                            ? ""
                            : e.target.value === "true",
                        part: 1,
                      });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="true">اعتباری</option>
                    <option value="false">غیر‌اعتباری</option>
                  </select>
                </div>
                <div className="col-12 col-md-2" style={{ marginTop: "37px" }}>
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={() => {
                      searchItemModal();
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearSearchModal}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive saletable mt-0">
                <table className="table table-striped table-md align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">نام</th>
                      <th scope="col vertical-center">نام‌خانوادگی</th>
                      <th scope="col vertical-center">موبایل</th>
                      <th scope="col vertical-center">اشتراک</th>
                      <th scope="col vertical-center">نوع مشتری</th>
                      <th scope="col vertical-center">اعتباری / غیراعتباری</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {merchantList.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(merchantFilter.part - 1) * merchantFilter.size +
                            index +
                            1}
                        </th>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.mobile}</td>
                        <td>{item.merchantCode}</td>
                        <td>
                          {item.merchantType === 1
                            ? "حقیقی"
                            : item.merchantType === 2
                            ? "حقوقی"
                            : ""}
                        </td>
                        <td>
                          {item.creditable === true ||
                          item.creditable === "true"
                            ? "اعتباری"
                            : "غیراعتباری"}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() =>
                              toggleCredittable(item.id, item.creditable)
                            }
                          >
                            انتخاب مشتری
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {merchantFilter.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPartMerchant(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItemsMerchant()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPartMerchant(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && WalletModal()}
      {showcreateMerchantModal && createMerchantModal()}
      {showsearchMerchantModal && searchMerchantModal()}
      {}
    </>
  );
};

export default MerchantWallet;
